__turbopack_context__.v({
  "root": "SkinTemperatureModal-module__OR9Mkq__root",
});
